import { InfoCircleFilled } from '@creditornot/cb-icons';
import { colors } from '@creditornot/cb-ingredients';
import { Tooltip } from '@creditornot/cb-popover';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import React from 'react';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

const InfoIcon = styled(InfoCircleFilled).attrs({
  width: 12,
  height: 12,
})`
  fill: ${cssThemedValue({ light: colors.pepper24, dark: colors.salt28 })};
  margin-inline-start: 4px;
`;

type HeaderProps = {
  title: string;
  tooltip?: string;
};
const SectionHeader = ({ title, tooltip }: HeaderProps) => (
  <T.Heading6>
    {title}
    {!!tooltip && (
      <Tooltip content={tooltip}>
        <InfoIcon />
      </Tooltip>
    )}
  </T.Heading6>
);

export default SectionHeader;
